import { ingestEvent } from "./api";

/**
 * Tiny telemetry helper used inside capability simulations.
 * Each simulation creates a recorder via createRecorder(attemptId, conceptId).
 * Recorder.log(event, detail?, payload?) sends the event to the backend
 * with a wall-clock-derived `time` (seconds since recorder creation) and
 * also keeps a local mirror so the on-screen ticker can show it.
 */
export function createRecorder(attemptId, conceptId, onLocalAppend) {
  const t0 = performance.now();
  const local = [];
  const log = async (event, detail = null, payload = null) => {
    const time = (performance.now() - t0) / 1000;
    const rec = { event, time, detail, payload, ts: new Date().toISOString() };
    local.push(rec);
    if (onLocalAppend) onLocalAppend(rec);
    try {
      await ingestEvent(attemptId, { concept_id: conceptId, event, time, detail, payload });
    } catch (e) {
      // swallow — local copy still valid for UX
    }
    return rec;
  };
  return { log, local, startedAt: Date.now() };
}
